/**
 * List View Plugin for Native Interactive Site Map (ISM)
 *
 * Orchestrates the listing sheet panel: header (title) and scrollable content area.
 * Writes into [data-panel] regardless of desktop sidebar or mobile drawer context.
 *
 * @module nativeInteractiveSiteMap/plugins/listView.plugin
 */

import createListingHeader from '../components/listingHeader.dom';
import createListingContent from '../components/listingContent.dom';

export default function createListViewPlugin() {
  const state = {
    header: null,
    content: null,
  };

  return {
    name: 'list-view',

    async init(context) {
      context.state.listView = {
        started: false,
        ready: false,
      };
    },

    async start(context) {
      if (context.state.listView?.started) {
        return;
      }

      context.state.listView = { started: true, ready: false };

      const panel = context.root.querySelector('[data-panel]');

      if (!panel) {
        return;
      }

      state.header = createListingHeader();
      state.content = createListingContent();

      panel.appendChild(state.header.getElement());
      panel.appendChild(state.content.getElement());

      state.header.setText('Available');

      context.state.listView.ready = true;
    },

    async stop(context) {
      state.header?.remove();
      state.content?.remove();
      state.header = null;
      state.content = null;
      context.state.listView = { started: false, ready: false };
    },
  };
}
